import React from 'react'
import { Avatar, Box, Button, Col, Dialog, FabButton, Flex, Gap, InputField, Row, SelectField, Typography } from '../../../../ppui'
import { SALARY_DETAILS_CONST } from '../pay-kyc-const'
import { BsFileEarmarkPdfFill } from 'react-icons/bs'
import { MdDriveFolderUpload } from 'react-icons/md'
const KycModal = ({
    onUpdatePayKyc,
    onChangeKYCdoc,
    alldocs,
    kycDoc,
    fileInputRef,
    handleButtonClick,
    handleFileChange,
    DeleteSpecificFile,
    openFileInNewTab,
    checkDocName,
    kycModalToggle,
    kycMOdal,
    paymentloader
}) => {
  return (
     <Dialog
       title="KYC Document"
       closeButton={true}
       fullWidth
       maxWidth="md"
       open={kycMOdal}
       onClose={kycModalToggle}
       onSubmit={()=>onUpdatePayKyc(kycModalToggle)}
       btnLoading={paymentloader}
     >
   
  
         <Flex direction="column" gap={30}>
             {
                     alldocs?.map((item, index) => (
                       <Row rowGap key={index}>
           
                         <Col sm={12} md={4} lg={8}>
                           <Flex gap={20}>
                             <Box>
                               <Avatar shape="square" icon={<BsFileEarmarkPdfFill />} />
                             </Box>
                             <Box>
                               <Typography variant="body2" mb={"0"} color={"dark"}>
                                 {item?.document_type}
                               </Typography>
                               <Typography variant="h5" mb={"0"}>
                                 {item?.document_number}
                               </Typography>
                             </Box>
                           </Flex>
                         </Col>
           
                         <Col sm={12} md={4} lg={4} xl={3} xxl={2}>
                           <Flex gap={10}>
                             <Button
                               onClick={() => DeleteSpecificFile(index)}
                               variant="filled"
                               size="sm"
                               color="danger"
                             >
                               Delete
                             </Button>
           
                             <Button
                               onClick={() => openFileInNewTab(item?.attachment)}
                               variant="filled"
                               size="sm"
                               color="primary"
                             >
                               View
                             </Button>
                           </Flex>
                         </Col>
                       </Row>
                     ))
                   }
        
            <Row rowGap>
                     <Col sm={12} md={4} lg={4} xxl={3}>
                       <SelectField
                         defaultValue={kycDoc?.document_type}
                         options={[
                           { id: "AAdhar", name: "AAdhar",disabled: checkDocName("AAdhar") },
                           { id: "Pan", name: "Pan",disabled: checkDocName("Pan") },
                           { id: "Passport", name: "Passport",disabled: checkDocName("Passport") },
                         ]}
                         onChange={(e) => onChangeKYCdoc(e, "document_type")}
                         {...SALARY_DETAILS_CONST.document_type}
                       />
                     </Col>
           
                     <Col sm={12} md={4} lg={4} xxl={3}>
                       <InputField
                         value={kycDoc?.document_number ? kycDoc?.document_number : ""}
                         valueSinc={!!kycDoc?.document_number}
                         onChange={(e) => onChangeKYCdoc(e, "document_number")}
                         {...SALARY_DETAILS_CONST.document_number}
           
                       />
                     </Col>
           
                     <Col sm={12} md={4} lg={4} xl={3} xxl={2}>
                       <FabButton
                         icon={<MdDriveFolderUpload />}
                         onClick={handleButtonClick}
                         shape="extended"
                         variant="contained"
                       >
                         Upload
                       </FabButton>
           
           
                       <input
                         ref={fileInputRef}
                         type="file"
                         accept=".png, .jpg, .jpeg, .doc, .docx, .pdf"
                         style={{ display: 'none' }}
                         onChange={handleFileChange}
                       />
                     </Col>
           
                   </Row>
         </Flex>
         <Gap height={100} />
     
   

     </Dialog>
  )
}

export default KycModal